import React, {Component} from "react"
import PropTypes from "prop-types"

import id from "@irati/utils/id"
import {Radio} from "@irati/ui/src/FormItem"
import {AreaOfInterestRenderer} from "../../Renderers"

export const PROPERTY = "interest"

class Interest extends Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array,
    name: PropTypes.string
  }

  static defaultProps = {
    name: PROPERTY,
    options: []
  }

  handleChange = (_, option) => {
    const {onChange, form, name} = this.props
    onChange(form, name, option)
  }

  render() {
    const idNamespace = id("Interest", this.props)
    const {form, name, options} = this.props

    const newValue = form.interest.id

    return (
      <>
        <Radio
          inline
          id={idNamespace}
          name={name}
          value={newValue}
          onChange={this.handleChange}
          rowRenderer={AreaOfInterestRenderer}
          options={options}
          justifyRadios="space-around" />
      </>
    )
  }
}

export default Interest
